import {CAMPAIGN, INTERNAL_ANALYTICS} from './serve/consts';
import {clear, get, set} from './serve/localStorage';

const KEEP_KEYS = [CAMPAIGN, INTERNAL_ANALYTICS];

export function clearLocalStorage() {
  const preserved = new Map<string, unknown>();

  KEEP_KEYS.forEach((key) => {
    const value = get(key);

    if (!value) {
      return;
    }

    preserved.set(key, value);
  });

  clear();

  preserved.forEach((value, key) => {
    set(key, value);
  });
}
